import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.ticketing.new');
import { OnInit, Input, DoCheck, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import moment from "moment";

@Component({
    selector: 'wiz-portal-gsdcuser-ticketing-new',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.ticketing.new/view.scss */
/* src/app/portal.gsdcuser.ticketing.new/view.scss: no such file or directory */`],
})
export class PortalGsdcuserTicketingNewComponent implements OnInit, DoCheck {
    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;

    public info: any = {};
    public saving: boolean = false;
    public tags: any = [];
    public tag: any = "";
    public files: any;

    public fd = new FormData();

    public async ngOnInit() {
        await this.service.init();
        await this.buildEditor();
        await this.service.render();
    }

    private notificationMessage(data: any): string {
        if (!data?.notification_warning) return "";
        return data.notification_queued === true
            ? "처리는 완료되었습니다. 알림 메일 발송이 지연되고 있습니다. 운영자에게 문의해주세요."
            : "처리는 완료되었지만 알림 메일 예약 여부를 확인하지 못했습니다. 같은 내용을 다시 등록하지 말고 운영자에게 문의해주세요.";
    }

    public async save() {
        if (this.saving) return;
        const title = typeof this.info.title === "string" ? this.info.title.trim() : "";
        if (!title) return await this.service.alert.error("제목을 입력해주세요.");
        if (!Array.isArray(this.tags) || !this.tags.length) {
            return await this.service.alert.error("태그를 선택해주세요.");
        }
        if (!this.editor) return await this.service.alert.error("편집기를 준비 중입니다. 잠시 후 다시 시도해주세요.");

        this.saving = true;
        let saved = false;
        try {
            const data = JSON.stringify({
                ...this.info, title, content: this.editor.data.get(), tag: this.tags
            });
            this.service.loading.show();
            let result: any;
            try {
                result = await wiz.call("save", { data });
            } finally {
                this.service.loading.hide();
            }
            if (result?.code !== 200) {
                const message = typeof result?.data === "string" ? result.data : result?.data?.message;
                await this.service.alert.error(message || "저장하지 못했습니다. 잠시 후 다시 시도해주세요.");
                return;
            }
            saved = true;
            const notice = this.notificationMessage(result.data);
            if (notice) await this.service.alert.warning(notice);
            else await this.service.alert.success("저장되었습니다.");
            await this.router.navigateByUrl('/support/ticketing');
        } catch (error) {
            if (saved) await this.service.alert.warning("처리는 완료되었지만 화면을 새로 고치지 못했습니다. 페이지를 새로고침해주세요.");
            else await this.service.alert.error("저장 결과를 확인할 수 없습니다. 연결 상태와 문의 목록을 확인해주세요.");
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async buildEditor() {
        this.info.content = "";
        let editor = this.editor = await ClassicEditor.create(document.querySelector("textarea#editor"), {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar", "Markdown"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.data.set(this.info.content);
    }

    public async tagAdd(target) {
        if (this.tags) this.tags.push(target);
        else this.tags = [target];
        await this.service.render();
    }

    public async tagRemove(target) {
        this.tags = this.tags.filter(tag => tag !== target);
        await this.service.render();
    }

    public async fileUpload(e) {
        if (!this.info.extra) this.info.extra = [];
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i]
            this.filename = file.name;
            if (!file.filepath) file.filepath = file.name;
            // this.fd.append('file[]', file);
            // this.fd.append('upload', file);
            // let fdurl = '/file/upload';
            this.fd.append('upload', file, file.name.includes(".") ? file.name : `${file.name}.jpg`);
            let fdurl = '/file/upload';
            if (!file.name.includes(".")) fdurl = fdurl + "/noext";
            const { url } = await this.service.file.upload(fdurl, this.fd, async (percent: number, total: number, position: number) => { });
            let fileInfo = { name: file.name, size: file.size, url: url }
            this.info.extra.push(fileInfo);
        }
        await this.service.render();
    }

    public removeAttachment(index: number) {
        this.info.extra = this.info.extra.filter((_, i) => i !== index);
    }

    public formatFileSize(bytes: number) {
        if (!Number.isFinite(bytes)) return '-';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0, size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return `${Math.round(size * 100) / 100} ${units[i]}`;
    }

    public getFileIcon(filename: string) {
        const ext = this.getExt(filename);
        switch (ext) {
            case 'pdf': return '📕';
            case 'doc':
            case 'docx': return '📝';
            case 'xls':
            case 'xlsx': return '📊';
            case 'ppt':
            case 'pptx': return '📈';
            case 'txt': return '📄';
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'webp': return '🖼️';
            default: return '📦';
        }
    }

    private getExt(name: string): string | null {
        const i = name.lastIndexOf('.');
        return i >= 0 ? name.slice(i + 1).toLowerCase() : null;
    }
}

export default PortalGsdcuserTicketingNewComponent;